import { Controller } from '@hotwired/stimulus'
import { api } from '../../api'

// Posts the picked folio as soon as it is chosen. Adding an account takes effect
// immediately rather than waiting for the container to be submitted, so there is
// nothing for a submit button to do.
export default class AccountPickerController extends Controller<HTMLElement> {
  declare readonly containerIdValue: string
  declare readonly containerSessionIdValue: string
  declare readonly selectTarget: HTMLSelectElement

  static targets = ['select']
  static values = { containerId: String, containerSessionId: String }

  async add() {
    const accountNumber = this.selectTarget.value
    // The rep code the folio is listed under, which Finfolio needs to resolve it.
    const repCodeValue = this.selectTarget.selectedOptions[0]?.dataset.repCode

    if (!accountNumber || !repCodeValue) return

    // Held disabled for the round trip so the same folio cannot be sent twice.
    this.selectTarget.disabled = true

    try {
      await api.accounts.create({
        accountNumber,
        containerSessionId: this.containerSessionIdValue,
        repCodeValue,
        submissionContainerId: this.containerIdValue,
      })
    } finally {
      this.selectTarget.disabled = false
    }
  }
}
